export const SYSTEM_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CREATED: 'CREATED',
  DEPLOYED: 'DEPLOYED',
};
